const faqs = [
  {
    question:
      "How long does SEO take to show results?",
    answer:
      "SEO is a long-term growth channel. Most businesses begin seeing measurable improvements within three to six months depending on competition and website authority."
  },

  {
    question:
      "Do you only work with businesses in Indore?",
    answer:
      "No. While we are based in India, we work with businesses across multiple cities and international markets."
  },

  {
    question:
      "Can you manage both marketing and website development?",
    answer:
      "Yes. Our approach combines strategy, marketing, technology and optimization into a unified growth system."
  },

  {
    question:
      "Do you offer ongoing support?",
    answer:
      "Yes. We provide long-term growth partnerships, optimization retainers and technical support."
  },

  {
    question:
      "What industries do you specialize in?",
    answer:
      "We commonly work with real estate, healthcare, education, manufacturing, ecommerce and technology businesses."
  }
];

export default faqs;